import React from "react";
import ReactDOM from "react-dom/client"; // ✅ Use 'react-dom/client'
import { Provider } from "react-redux";
import { HashRouter } from "react-router-dom";

import App from "./App";
import store from "./store/store";

import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <HashRouter>
        <App />
      </HashRouter>
    </Provider>
  </React.StrictMode>
);
